module.exports = __webpack_public_path__ + "static/media/createContent.90137c65.png";